import {FC, useEffect, useState} from 'react'
import {ChildrenInterface} from '../../../global'
import {initialState, UserContext, UserInterface} from './types'
import SetupAxios from '../../../setup/axios/SetupAxios'
import axios from 'axios'
import {API_URL} from '../all-pages'
import {useLocation} from 'react-router-dom'
import {useQuery} from 'react-query'

const GET_USER = process.env.REACT_APP_GET_USER || 'get_user'

const fetchUserData = async (token: string): Promise<UserInterface> => {
    const response = await axios({
        method: 'GET',
        url: `${API_URL}${GET_USER}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    return response.data
}

export const UserProvider: FC<ChildrenInterface> = ({children}) => {
    const [personalInformation, setPersonalInformation] = useState<UserInterface>(initialState)
    const {pathname} = useLocation()
    const token = localStorage.getItem("_token")
    const segments = pathname.split('/token/')
    const newToken = segments[1]
    const activeToken = newToken || token

    const { isLoading, error } = useQuery<UserInterface, Error>(
        ['userData', activeToken],
        () => fetchUserData(activeToken as string),
        {
            enabled: !!activeToken, // Ne lance la requête que si un token est disponible
            onSuccess: (data) => {
                localStorage.setItem('_userInterface', JSON.stringify({ data, timestamp: Date.now() }))
                localStorage.setItem('_clientCreationDate', data.created_at)
                localStorage.setItem('_token', activeToken as string)
                setPersonalInformation(data)

                if (newToken) {
                    window.location.href = "/dashboard"
                }
            },
            onError: (err) => {
                console.error('Error fetching user data:', err)
                // Vous pourriez aussi gérer les erreurs ici (comme déconnecter l'utilisateur)
            }
        }
    )

    // Gestion de l'état de chargement et d'erreur si nécessaire
    if (isLoading) return <div>Loading...</div>
    if (error) return <div>Error: {error.message}</div>

    return (
        <UserContext.Provider value={{personalInformation, setPersonalInformation}}>
            {children}
        </UserContext.Provider>
    )
}









// import {FC, useEffect, useState} from 'react'
// import {ChildrenInterface} from '../../../global'
// import {initialState, UserContext, UserInterface} from './types'
// import axios from 'axios'
// import {API_URL} from '../all-pages'
// import {useLocation} from 'react-router-dom'
// const GET_USER = process.env.REACT_APP_GET_USER || 'get_user'
//
// const fetchData = async (token: string): Promise<UserInterface> => {
//     try {
//         const response = await axios({
//             method: 'GET',
//             url: `${API_URL}${GET_USER}`,
//             headers: {
//                 Authorization: `Bearer ${token}`,
//             },
//         })
//         return response.data
//     } catch (error) {
//         console.error('Error during login:', error)
//         throw error
//     }
// }
//
// export const UserProvider: FC<ChildrenInterface> = ({children}) => {
//
//     const [personalInformation, setPersonalInformation] = useState<UserInterface>(initialState)
//     const {pathname} = useLocation();
//     const token = localStorage.getItem("_token")
//     const segments = pathname.split('/token/');
//     const newToken = segments[1];
//
//     useEffect(() => {
//
//         if (newToken) {
//             fetchData(newToken)
//                 .then(r => {
//                     console.log("---------------------------  ", r)
//                     localStorage.setItem('_userInterface', JSON.stringify({ data: r, timestamp: Date.now() }));
//                     localStorage.setItem('_clientCreationDate', r.created_at);
//                     localStorage.setItem('_token', newToken);
//                     setPersonalInformation(r)
//                     window.location.href = "/dashboard"
//                 })
//                 .catch((e) => {
//                     console.log(e)
//                 })
//         } else if (token) {
//             fetchData(token)
//                 .then(r => {
//                     localStorage.setItem('_userInterface', JSON.stringify({ data: r, timestamp: Date.now() }));
//                     localStorage.setItem('_clientCreationDate', r.created_at);
//                     localStorage.setItem('_token', token);
//                     setPersonalInformation(r)
//                 })
//                 .catch((e) => {
//                     console.log(e)
//                 })
//         }
//     }, [newToken, token])
//
//     // useQuery('UserInfos', () => fetchData(GET_USER), {
//     //     onSuccess: (newData) => {
//     //         setPersonalInformation(newData)
//     //     },
//     // })
//
//     return (
//         <UserContext.Provider value={{personalInformation, setPersonalInformation}}>
//             {children}
//         </UserContext.Provider>
//     )
// }
//
